<template>
  <a-drawer v-model:visible="drawer" :title="title" placement="right" width="70%">
    <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
      :pagination="{ current: page, pageSize: limit, total: count, showQuickJumper: true, showSizeChanger: true, showTotal: (total) => `共${total}条`, }"
      @change="(pagination) => { page = pagination.current; limit = pagination.pageSize; }">
      <template #title>
        <a-button type="primary" :loading="dataLoading" @click="getData">刷新</a-button>
      </template>
      <template #bodyCell="{ record, column, index }">
        <template v-if="column.dataIndex === 'index'">
          {{ index + 1 }}
        </template>
        <template v-if="column.dataIndex === 'file'">
          <a href="javascript:;" @click="downloadfile(record)">{{ record.originalname }}</a>
        </template>
        <template v-if="column.dataIndex === 'state'">
          <a-tag v-if="record.state === 0" color="processing">正在处理</a-tag>
          <a-tag v-if="record.state === 1" color="success">成功</a-tag>
          <a-tag v-if="record.state === -1" color="error">失败</a-tag>
        </template>
        <template v-if="column.dataIndex === 'operation'">
          <a-space>
            <a v-if="record.remoteurl" href="javascript:;" @click="downloadfile(record)">下载</a>
            <a-popconfirm v-if="record.state === -1" title="确定要删除?" @confirm="remove(record._id)">
              <a href="javascript:;" class="text-error">删除</a>
            </a-popconfirm>
          </a-space>
        </template>
      </template>
    </a-table>
  </a-drawer>
</template>
<script setup>
import { ref, watch, computed, onActivated, getCurrentInstance, } from "vue";
import _ from "underscore";
import { message } from "ant-design-vue";
const { proxy } = getCurrentInstance();
const title = ref('');
const type = ref('');
const drawer = ref(false);
const dataLoading = ref(false);
const page = ref(1);
const limit = ref(10);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const width = computed(() => proxy.$utils.twidth(columns));
const columns = computed(() => {
  return [
    { title: '序号', dataIndex: 'index', width: 80 },
    { title: '文件', dataIndex: 'file', width: 200, },
    { title: '状态', dataIndex: 'state', width: 100, },
    { title: '原因', dataIndex: 'reason', width: 100, },
    { title: '时间', dataIndex: 'create_time', width: 120, },
    { title: '操作', dataIndex: 'operation', width: 100, },
  ];
})
onActivated(() => {
  console.log("onActivated");
  getData();
});
watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});
const showDownload = ({ title: v1, type: v2 }) => {
  title.value = v1;
  type.value = v2;
  drawer.value = true;
  // TODO
  getData();
}
const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/downloadtask/list", { page: page.value, limit: limit.value, type: type.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const remove = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/downloadtask/remove", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const downloadfile = (record) => {
  if (record.remoteurl) {
    proxy.$utils.download(record.remoteurl, record.originalname);
  }
}
defineExpose({
  showDownload,
})
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}
</style>